// extracted by mini-css-extract-plugin
module.exports = {"button":"idt-button_button__1_scf"};